import * as React from 'react';
import { WatchedShipment } from 'services/clients/watchList';
import { DateTime } from 'luxon';
import { CellProps } from './types';
import { Cell } from './Cell';

const DATE_FORMAT = 'EEE, MMM d';

export const DateAddedCell: React.FC<CellProps> = (props) => {
  const watch: WatchedShipment = props.row;
  const date = DateTime.fromISO(watch.createdAt);
  return <Cell>{date.toFormat(DATE_FORMAT)}</Cell>;
};
DateAddedCell.displayName = 'AddContainers.RecentlyAdded.Table.DateAddedCell';
